// export enum Colors{
//   Green="#19fa55",
//   Blue="#25e3f5",
//   Yellow="#f5ea25",
//   Red="#f52525",
//   Indigo="#3f51b5",
//   Pink="#fa1977",
//   Black="#333"
// }
// export interface Theme{
//   secondary:  string;
//   primary: string;
//   darkMode: boolean;
// }

export class Theme {
  secondary: string;
  accent: string;
  primary: string;
  darkMode: boolean;
  label: string;
  value: string;
  customValues?: any;
}
export const themes: Array<Theme> = [
  {
    darkMode: false,
    secondary: '#f9f3e9',
    accent:"#8C8C8C",
    primary: '#2a0c08',
    label: 'Woodgrove Groceries',
    value: 'groceries',
    customValues:{
      '--app-primary':'#2a0c08',
      '--app-secondary':'#f9f3e9',
      '--app-primary-font':'#FFFFFF',
      '--app-secondary-font': '#8C8C8C'
    }
  },
  {
    darkMode: false,
    secondary: '#B5DDDD',
    accent:"#8C8C8C",
    primary: '#2D3338',
    label: 'Woodgrove Health',
    value: 'health',
    customValues:{
      '--app-primary':'#2D3338',
      '--app-secondary':'#B5DDDD',
      '--app-primary-font':'#FFFFFF',
      '--app-secondary-font': '#8C8C8C'
    }
  },
  {
    darkMode: false,
    secondary: '#dbeadd',
    accent:"#8C8C8C",
    primary: '#212121',
    label: 'Woodgrove Finance',
    value: 'finance',
    customValues:{
      '--app-primary':'#212121',
      '--app-secondary':'#dbeadd',
      '--app-primary-font':'#FFFFFF',
      '--app-secondary-font': '#8C8C8C'
    }
  },
];
